// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1ylVr","obliqueLineWrap":"membershipbadge_obliqueLineWrap__QzDWc","obliqueLine":"membershipbadge_obliqueLine__3d3e4"};